module.exports = __webpack_public_path__ + "assets/xiwang-silogan-transp.facd8cf.png";